module.exports = __webpack_public_path__ + "static/media/tipo6.01fee261.png";